import angular from 'angular'

/**
 * Map of key codes and key name
 */
const KEY_CODES = {
  13: 'ENTER',
  27: 'ESC',
  32: 'SPACE',
  37: 'LEFT',
  38: 'UP',
  39: 'RIGHT',
  40: 'DOWN',
}

/**
 * Low level service to work with keyboard keys.
 *
 * @example
 * <p>Register a single key event:</p>
 * <vd-code-block>
 *   var listener = key.on('ESC', callback)
 * </vd-code-block>
 *
 * <p>Remove the key:</p>
 * <vd-code-block>
 *   listener.off()
 * </vd-code-block>
 *
 * <p>Register multiple events:</p>
 * <vd-code-block>
 *   key.on({
 *      ESC: close,
 *      ENTER: submit
 *   })
 * </vd-code-block>
 *
 * <p>Prevent the default action:</p>
 * <vd-code-block>
 *   key.on({
 *      UP: prev,
 *      DOWN: next
 *   }, { preventDefault: true })
 * </vd-code-block>
 */
angular.module('webregister.factories').factory('key', function () {
  function get(keyCode) {
    return KEY_CODES[keyCode]
  }

  /**
   * Set one or many key handler on a element.
   *
   * @param {jQuery} element The element on which to attach the handlers.
   *
   * @param {object|string} keyActionMap Either a key name or a map of key/actions.
   *
   * @param {function} [action] The action to trigger, if using the single key format.
   *
   * @param {object} [options] Listener options
   *
   *        @param {object} [options.preventDefault] Prevent the default event action
   *
   * @return {KeyListener} A key listener instance
   */
  function on(element, keyActionMap, options) {
    if (angular.isString(keyActionMap)) {
      const key = keyActionMap
      keyActionMap = {}
      keyActionMap[key] = options
    }

    element.on('keydown', handler)

    function handler(e) {
      if (keyActionMap[get(e.which)]) {
        if (options && options.preventDefault) {
          e.preventDefault()
        }

        keyActionMap[get(e.which)]()
      }
    }

    /**
     * Remove key handler
     *
     * @memberof KeyListener#
     */
    function off() {
      element.off('keydown', handler)
    }

    return { off }
  }

  return { on }
})
